import script from "./textToggler.vue?vue&type=script&setup=true&lang=ts"
export * from "./textToggler.vue?vue&type=script&setup=true&lang=ts"

import "./textToggler.vue?vue&type=style&index=0&id=ccb129c4&lang=css"

const __exports__ = script;

export default __exports__